module.exports = __webpack_public_path__ + "static/media/icon_x_red.bcaf8ce3.svg";